var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6349 0.666436C15.1765 -0.222144 17.0659 -0.222146 18.6075 0.666434L29.6995 7.06001C31.2715 7.9661 32.2424 9.6578 32.2424 11.4906V24.1458C32.2424 25.9786 31.2715 27.6703 29.6995 28.5764L18.6075 34.9699C17.0659 35.8585 15.1765 35.8585 13.6349 34.9699L2.54289 28.5764C0.97093 27.6703 0 25.9786 0 24.1458V11.4906C0 9.6578 0.970927 7.9661 2.54288 7.06001L13.6349 0.666436Z",
    fill: "#9AE440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8848 1.09961C15.2717 0.300227 16.9705 0.300295 18.3574 1.09961L29.4502 7.49316C30.8651 8.30884 31.7421 9.83417 31.7422 11.4902V24.1455C31.7422 25.8018 30.8653 27.3278 29.4502 28.1436L18.3574 34.5371C16.9706 35.3363 15.2716 35.3364 13.8848 34.5371L2.79297 28.1436C1.37783 27.3279 0.5 25.8018 0.5 24.1455V11.4902C0.500133 9.83407 1.37793 8.3088 2.79297 7.49316L13.8848 1.09961Z",
    stroke: "white",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexGreen);
export default __webpack_public_path__ + "static/media/hex-green.9acbd295e82b10ae222b0475019b7075.svg";
export { ForwardRef as ReactComponent };